import { useParams } from 'react-router-dom';

export function SharedLevelScreen() {
  const { slug } = useParams<{ slug: string }>();
  return (
    <main data-testid="screen-shared-level">
      <h1>Уровень {slug}</h1>
    </main>
  );
}
